import { SourceType } from '@aloft/toolkit-shared';

export const FEATURE_GRID_DATA_SOURCES: SourceType[] = ['abode_mls', 'abode_public_record'];
